// Add your custom JS here.
var console = window.console;


jQuery(document).ready(function($){

  $('#lang-menu').click(function() {
    const $navbarNavDropdown = $('#navbarNavDropdown'); // Main menu dropdown
    const $navbarLangDropdown = $('#navbarLangDropdown'); // Language dropdown

    // Check if the main menu dropdown is open, if so, hide it
    if ($navbarNavDropdown.hasClass('show')) {
      $navbarNavDropdown.collapse('hide');
    }
  });

  // Handle when the main menu button is clicked
  $('#nav-menu').click(function() {
    const $navbarNavDropdown = $('#navbarNavDropdown'); // Main menu dropdown
    const $navbarLangDropdown = $('#navbarLangDropdown'); // Language dropdown

    // Check if the language dropdown is open, if so, hide it
    if ($navbarLangDropdown.hasClass('show')) {
      $navbarLangDropdown.collapse('hide');
    }
  });

  let items = document.querySelectorAll('.carousel .carousel-item')

      items.forEach((el) => {
        const minPerSlide = 2
        let next = el.nextElementSibling
        for (var i=1; i<minPerSlide; i++) {
          if (!next) {
              // wrap carousel by using first child
              next = items[0]
          }
          let cloneChild = next.cloneNode(true)
          el.appendChild(cloneChild.children[0])
          next = next.nextElementSibling
      }
  })
});
